import styled from 'styled-components';

import { BaseStyle } from '@nhl/nhl-breakaway-ui';

export const Wrapper = styled.div`
    ${BaseStyle.Mixins.fontStyles.ui['10m']};
    color: ${({ theme }) => theme.Text.secondary};
`;
